export const expandMeetingSchema = {
  period: "",
  createdBy: "",
  organizationId: "",
  meetingSchedule: "",
  locationId: "",
  meetingName: "",
  meetingdate: "",
  meetingType: "",
  venue: "",
  participants: [],
  minutesofMeeting: "",
  attachments: [],
  agenda: [],
};
